import { useOnScreenEditorsContext } from "@/context/OnScreenEditorsContext";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect, useId } from "react";

export function useStoreEditorOnScreen(location?: "sidebar" | "main") {
  const { dispatchOnScreenEditors } = useOnScreenEditorsContext();
  const [editor] = useLexicalComposerContext();
  const id = useId();

  useEffect(() => {
    if (!location) return;
    dispatchOnScreenEditors({
      type: "add",
      id,
      editor,
      location,
    });

    return () => {
      dispatchOnScreenEditors({
        type: "remove",
        id,
      });
    };
  }, [dispatchOnScreenEditors, editor, id, location]);
}
